import React from 'react'
import { HashLoader } from 'react-spinners'

export const CustomLoader = ({ message}) => {
  return (
      <div className='loader'>
          <HashLoader css={'top:50%'} color='yellow' size={100} loading={true} speedMultiplier={2} />
          <p className="h5 loader-text" > {message} </p>
      </div>
  )
}
